
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRainShowersDay as ObiRainShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rain-showers-day.js';
 
 
 

 
 export const ObiRainShowersDay = createComponent({
   react: React,
   tagName: 'obi-rain-showers-day',
   elementClass: ObiRainShowersDayElement,
   events: {
     
   }
  });
 
 